interface ViewToggleProps {
  view: 'all' | 'pocket';
  onChange: (view: 'all' | 'pocket') => void;
  pocketCount: number;
}

export default function ViewToggle({ view, onChange, pocketCount }: ViewToggleProps) {
  return (
    <div className="bg-gray-800/50 backdrop-blur-sm border-b border-gray-700/50 sticky top-0 z-20 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => onChange('all')}
            className={`px-6 py-3 rounded-xl font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
              view === 'all'
                ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-lg shadow-cyan-500/30'
                : 'bg-gray-700/50 text-gray-300 hover:bg-gray-700'
            }`}
          >
            전체 게임
          </button>
          <button
            onClick={() => onChange('pocket')}
            className={`px-6 py-3 rounded-xl font-semibold text-sm transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 ${
              view === 'pocket'
                ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-lg shadow-cyan-500/30'
                : 'bg-gray-700/50 text-gray-300 hover:bg-gray-700'
            }`}
          >
            <span>내 주머니</span>
            {pocketCount > 0 && (
              <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                view === 'pocket' 
                  ? 'bg-white/20 text-white' 
                  : 'bg-cyan-500 text-white'
              }`}>
                {pocketCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
